<template>

    <transition name="el-zoom-in-top">
     
        <div class="content-wrapper">
           
       <!-- Content Header (Page header) -->
        <section class="content-header">
         
        </section>
  
            <!-- Main content -->
            <section class="content">
                <div class="box">
                <loading v-show="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"/>
                    <div class="box-body" style="min-height:400px;">
                        <h3><strong>Update Accident Information</strong></h3>
                        <hr>
                        <div class="account-box">
                        <form role="form">

                        <div class="form-group"> 
                        
                                <label for="inputName">Accident Name: </label>
                                <input id="inputName" v-model="accidentName"   class="form-control">
                                </div>
                        
                    <hr>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Accident Type: </label>
                                <br>
                                <el-select v-model="accidentTypeSelect" :placeholder="accidentTypeSelect">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                        
                    </div>
                                        <hr>

                        <div class="form-group"> 
                                <label for="inputPassword">Accident Location: </label>
                                  
                                <input id="inputPassword" v-model="accidentLocation"   class="form-control">
                               
                    </div>
                                        <hr>
 <div class="form-group"> 
                        
                                <label for="example-datepicker">Date of Accident: </label>
    <date-picker id="example-datepicker" v-model="dateValue" class="mb-2"></date-picker>
                           <br>
    <br>
     <div>
                           <label for="example-timepicker">Time of accident: </label>

    <time-picker format="hh:mm A" v-model="timeValue" locale="en"></time-picker>
    <br>
                    </div>
 </div>
                                        <hr>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Additional Accident Information: </label>
                                <el-input type="textarea" :rows="4" id="inputPassword" v-model="additionalInfoTextArea"  :placeholder="additionalInfoTextArea"></el-input>
                        
                    </div>
                                        <hr>

                        <div class="form-group"> 
                        
                             <p><strong>Please select the Make and Model of your Vehicle:</strong></p>
                    <br>
                    <h4>Make</h4>
                      <el-select v-model="makeValue" :placeholder="makeValue" @change="updateModelDropdown()">
                        <el-option
                          v-for="item in this.makeOptions"
                          :key="item.brand"
                          :label="item.brand"
                          :value="item.brand">
                        </el-option>
                      </el-select>
                      <h4>Model</h4>
                        <el-select v-model="modelValue" :placeholder="modelValue" :disabled="modelOptions.length===0">
                        <el-option
                          v-for="item in this.modelOptions"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <h4>Year</h4>
                        <el-select v-model="yearValue" :placeholder="yearValue">
                        <el-option
                          v-for="item in yearOptions"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>
<hr>
              <div class="form-group">
<h4><strong>Services Needed</strong></h4>
<hr>
                    <p>Please select the service(s) you would like to receive for your accident:</p>
                    <br>
                      <el-checkbox-group v-model="servicesNeededCheckList" style="overflow: auto;">
                        <el-tooltip class="item" effect="dark" content="Have medical services assist you with your injuries." placement="top">
                        <el-checkbox  label="Medical"></el-checkbox>
                        </el-tooltip>
                        <el-checkbox label="Towing"></el-checkbox>
                        <el-tooltip class="item" effect="dark" content="Get legal assistance to help with your auto accident." placement="top">
                        <el-checkbox label="Legal"></el-checkbox>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Rent a vehicle to get around in the meanwhile." placement="top">
                        <el-checkbox label="Car Rental Service" ></el-checkbox>
                        </el-tooltip>
                                                <el-tooltip class="item" effect="dark" content="Look for a new vehicle." placement="top">

                        <el-checkbox label="Auto-Dealership" ></el-checkbox>
                                                </el-tooltip>
                      </el-checkbox-group>
              </div>
                      <hr>
                    <div class="form-group"> 
                        
                                <label for="inputPassword">Vehicle Speed (in MPH): </label>
    <br>
                    <div class="block"> 
                        <el-slider v-model="vehicleSpeedValue" show-input></el-slider>
                    </div>
                    </div>
                    <hr>
                    <br>
     <div class="box">
                    <div class="box-header with-border">
                        <h3 class="box-title">Uploaded File(s)</h3>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                    <div  class="box-body">
                        <el-table
                        id="uploadedFileList"
                        empty-text="No files uploaded."
                        :data="uploadedFileList"
                        style="width: 100%">
                        
                       
               
                        <el-table-column
                          label="File Name"
                          >
                         <template slot-scope="scope">
    <span class="bold"><i class="dripicons-document-new"></i>&nbsp&nbsp{{scope.row.fileName}}</span>
                </template>
                        </el-table-column>
                         
                         <el-table-column
                          label="Date Uploaded"
                         >
                         <template slot-scope="scope">
                         {{scope.row.dateUploaded}}
                         </template>
                        </el-table-column>
                         <el-table-column
                          label="Options"
                          >
                          <template scope="props">
                            <a>
                         <i 
  @click.prevent="downloadFile(props.row.filePath, props.row.fileName, props.row.contentType)" class="material-icons">file_download</i></a>&nbsp&nbsp<a><i @click="deleteFile(props.row.filePath, props.row.fileName, props.row.fileId)" class="material-icons">delete</i> </a>
                                                 
                         </template>
                        </el-table-column>
                      </el-table>
                     
                    </div>
               
                     <div class="box-footer ">
               
<div class="box-body" style="text-align: center;">
                         
                         <!--keep "auto-upload" set to false to prevent CORS issues-->

                        <el-upload
                          class="upload-demo"  
                          action="https://jsonplaceholder.typicode.com/posts/"
                         list-type="picture"
                          :auto-upload="false"                            
                          :on-remove="handleRemove"
                          :file-list="fileList"
                          :on-preview="handlePreview"
                          :on-success="handleSuccess"
                          :http-request="uploadFiles"
                          :multiple="true"
                          :on-error="handleError"
                          :on-change="handleChange"
                          :before-upload="beforeUpload"
                          :limit="10"
                          :on-exceed="handleExceed"
                          >
                          <el-button size="small" type="primary">Select New File(s) to Upload</el-button>
                          <div slot="tip" class="el-upload__tip">Media files with a size less than 10Mb(limit of 10 files)</div>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" :title="fileNameSelected">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
<br>
                          <el-button v-on:click="uploadFiles()" v-show="this.fileList.length > 0" size="small" type="primary">Upload <span>{{this.fileList.length}}</span> File<span v-show="this.fileList.length > 1">s</span></el-button>

                    </div> 
                        
                    </div>
                    </div>
                        </form>
                        </div>
                                        <hr>

            
                    <br>
                    <br>
                    <hr>
                                <div class="col-md-12 row-block"> <a class="btn btn-primary btn-block" href='#' v-on:click="saveChanges">Save Changes</a> </div>

                    <hr>
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
/*NOTE TODO: We should probably have some sort of versioning to keep track of when users do the following to the files
 - Upload new files, delete files, download files, overwrite existing files, restore file versions, etc. along with
(date of execution action, version number(if applicable), other metadata relevant to keeping a precise, streamlined account of the files for each accident.)
 */

import Buttons from "./modules/ui/Buttons.vue";
const storage = require('../services/Storage/storage')
const cliStorage = require("../services/libraries/clientStoragelib");
const cliStorNames = cliStorage.clientStorageNames;
import utilityFunctions from '../common/utilityFunctions'
import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
var to = require("await-to-js").default;
const db = require("../services/database/database");
  const commonDB = require('../services/database/common')

const Auth = require("../services/Authentication/auth");
const cliStoreOps = require("../common/clientStorageOperations");
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TimePicker from 'vue2-timepicker';
const { v4: uuidv4 } = require('uuid');
import 'vue2-timepicker/dist/VueTimepicker.css';
const vehicleMakeModel = require('../store/vehicleMakeModelList.json')
const models = require('../services/database/models')

export default {
  components: { Buttons, DatePicker, TimePicker, Loading },
  name: "editAccident",
  props: ["user"],
  watch: {
    input: function () {
      if (
        isLocalStorage() /* function to detect if localstorage is supported*/
      ) {
        localStorage.setItem("storedData", this.input);
      }
    },
  },
   async beforeMount(){
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!userToken){
         
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
        }
        this.userToken = userToken
        const jwt_decode = require('jwt-decode');
      const decoded_header = jwt_decode(this.userToken)
      this.userAccountId = decoded_header.user_id
    
        const accidentId = this.$route.params.accidentId
        this.accidentId = accidentId
        console.log("accident ID:", accidentId)
        if (!accidentId){
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

          console.error("no accident ID")
        }
        console.log("here created")
        let userErr, userRes;
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
           cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
          } else if (userRes) {
              console.log("userRes",userRes)
              const userId = this.$cookie.get(cliStorNames.USER_ID.name)
              if (!userId)
              {
                //TODO: eventually need to add plan B here, maybe just look up the user and get the ID
                console.warn("No user id found.")
              }
              this.userId = userId
 let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
               let dbRes, dbErr; 
                  [dbErr, dbRes]= await to(commonDB.getAccidentFromDB(this.userToken, this.userAccountId, this.accidentId))
                  if (dbErr){
                      console.error("Error", dbErr)
                      this.$confirm("Unable to retrieve Accident Entry. Please try again at a later time.", 'Edit Accident Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/')) //take user to home page
                  }
                  console.log(dbRes)
                  try{
                 
                  //should only be one entry
                 
                                      let accident = {};
                    
                                          accident.accidentName = dbRes.data.fields.accidentName.stringValue

                      accident.accidentType = dbRes.data.fields.accidentType.stringValue
              accident.accidentTime = dbRes.data.fields.accidentTime.stringValue
              accident.vehicleMake = dbRes.data.fields.vehicleMake.stringValue
              accident.vehicleModel = dbRes.data.fields.vehicleModel.stringValue
              accident.vehicleYear = dbRes.data.fields.vehicleYear.stringValue
              accident.vehicleSpeed = dbRes.data.fields.vehicleSpeed.stringValue
              accident.accidentId = dbRes.data.fields.accidentId.stringValue,
              accident.accidentLocation = dbRes.data.fields.accidentLocation.stringValue
              accident.accidentClaimStatus = dbRes.data.fields.accidentClaimStatus.stringValue
              accident.additionalAccidentInformation = dbRes.data.fields.additionalAccidentInformation.stringValue
              console.log(new Date(parseInt(dbRes.data.fields.timeSubmitted.stringValue)))
               accident.timeSubmitted = new Date(parseInt(dbRes.data.fields.timeSubmitted.stringValue)).toString() 
               accident.accidentDate = new Date(dbRes.data.fields.accidentDate.stringValue).toString()

                if (accident.accidentDate === "Invalid Date"){
                                accident.accidentDate = dbRes.data.fields.accidentDate.stringValue

                }
              
 accident.accidentDate = new Date(dbRes.data.fields.accidentDate.stringValue).toString()
               accident.filesUploaded = []
               //NOTE: firebase returns undefined for empty array fields in firestore DB
               if ( dbRes.data.fields.filesUploaded.arrayValue.values)
               {
              accident.filesUploaded =  dbRes.data.fields.filesUploaded.arrayValue.values

               }
                if (accident.accidentDate === "Invalid Date"){
                                accident.accidentDate = dbRes.data.fields.accidentDate.stringValue

                }
                accident.accidentServicesRequested = []
               if ( dbRes.data.fields.accidentServicesRequested.arrayValue.values)
               {
              accident.accidentServicesRequested = dbRes.data.fields.accidentServicesRequested.arrayValue.values

               }              
               console.log("services",  accident.accidentServicesRequested)
              this.accidentList.push(accident)
        
                  

                  this.accidentName = this.accidentList[0].accidentName
                  this.accidentDate = this.accidentList[0].accidentDate
                  this.accidentTypeSelect = this.accidentList[0].accidentType
                  this.accidentLocation = this.accidentList[0].accidentLocation
                  this.vehicleSpeedValue = parseInt(this.accidentList[0].vehicleSpeed)
                  this.makeValue = this.accidentList[0].vehicleMake
                  this.modelValue = this.accidentList[0].vehicleModel
                  this.yearValue = this.accidentList[0].vehicleYear
                  this.additionalInfoTextArea = this.accidentList[0].additionalAccidentInformation
                  this.dateValue = this.accidentList[0].accidentDate
                  this.timeValue = this.accidentList[0].accidentTime
                  this.filesUploaded = this.accidentList[0].filesUploaded

                  for(var services of this.accidentList[0].accidentServicesRequested){
                  this.servicesNeededCheckList.push(services.stringValue)  
                  

                  }
                  console.log("accidentType", this.accidentName)
                  console.log("filesUploaded", this.accidentList[0].filesUploaded)
                  let parsedFilesUploadedArr = utilityFunctions.parseArrayOfObjectsFirestoreDB(this.filesUploaded)
                                    console.log("parsedfilesUploaded", parsedFilesUploadedArr)

                 this.uploadedFileList = this.createFileDisplayList(parsedFilesUploadedArr)
                  this.parsedFilesUploaded = parsedFilesUploadedArr
                  }
                  catch(err){
                    console.error(err)
                     this.$confirm("Unable to retrieve Accident Entry. Please try again at a later time.", 'Edit Accident Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }

              
          

                  

      }
      
      },
  
  //need to clear fro local str maybe
  created() {
    //       if (window.localStorage) {
    //                 if (!localStorage.getItem(cliStorNames.FIRST_NAME.name)){
    //                 localStorage.setItem(cliStorNames.FIRST_NAME.name, this.$route.params.user.firstName)
    //                 }
    // {
    //                                 if (!localStorage.getItem(cliStorNames.LAST_NAME.name))
    //                 localStorage.setItem(cliStorNames.LAST_NAME.name, this.$route.params.user.lastName)
    // }
    //                 if (!localStorage.getItem(cliStorNames.EMAIL.name)){
    //                 localStorage.setItem(cliStorNames.EMAIL.name, this.$route.params.user.email)
    //                 }
    //                                 if (!localStorage.getItem(cliStorNames.PHONE.name)){
    //                 localStorage.setItem(cliStorNames.PHONE.name, this.$route.params.user.phone)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.CITY.name)){
    //                                                     localStorage.setItem(cliStorNames.CITY.name, this.$route.params.user.city)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.STATE.name)){
    //                                                     localStorage.setItem(cliStorNames.STATE.name, this.$route.params.user.state)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.ZIPCODE.name)){
    //                 localStorage.setItem(cliStorNames.ZIPCODE.name, this.$route.params.user.zipcode)}
    //       }

  },
  beforeDestroy() {
    //   if (window.localStorage) {
    //     localStorage.removeItem(cliStorNames.FIRST_NAME.name)
    //   localStorage.removeItem(cliStorNames.LAST_NAME.name)
    //   localStorage.removeItem(cliStorNames.CITY.name)
    //    localStorage.removeItem(cliStorNames.EMAIL.name)
    //  localStorage.removeItem(cliStorNames.PHONE.name)
    //   localStorage.removeItem(cliStorNames.STATE.name)
    //     localStorage.removeItem(cliStorNames.ZIPCODE.name)
    //  localStorage.removeItem(cliStorNames.USER_ID.name)
    //   }
  },

  data() {
    return {
      action: "http://localhost:8080/?#/accidentInformationPage",
      active: true,
      userAccountId: "",
      userToken: "",
      isLoading: false,
                fullPage: true,
      uploadedFileList: [],
            parsedFilesUploaded: [],
      fileList: [],
      modelOptions: [],
              servicesNeededCheckList: [],
      accidentList: [],
      dbDocumentPath : "",
      yearOptions: [
        1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991,
        1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003,
        2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
        2016, 2017, 2018, 2019, 2020, 2021, 2022,
      ],
      makeOptions: vehicleMakeModel,
      vehicleSpeedValue: 0,
      dateValue: "",
      files: "",
      dialogImageUrl: "",
      dialogVisible: false,
      inputFile: {},
      inputFilter: {},
      timeValue: "",
      accidentName: "",
      servicesNeededCheckList: [],
      fileNameSelected: "",
      options: [
        {
          value: "rearEnd",
          label: "Rear-End",
        },
        {
          value: "headOn",
          label: "Head-On",
        },
        {
          label: "Fender-Bender",
          value: "fenderBender",
        },
        {
          value: "sideImpactCollision",
          label: "Side-impact collision",
        },
        {
          value: "singleCar",
          label: "Single Car Accident(No other driver involved)",
        },
      ],
      accidentTypeSelect: "",
      accidentTimeRadio: "",
      accidentLocation: "",
      additionalInfoTextArea: "",
      makeValue: "",
      makeObj: {}, //obj to extract models and name
      modelValue: "",
      yearValue: "",
      accidentObj: {},
      accidentId: '',
      upload: {
        active: false,
      },
    };
  },
  methods: {
    createFileDisplayList(fileArr){
      let uploadedFileList = [];
             for(let fileObj of fileArr){
                    const fileName = utilityFunctions.getFileNameFromStoragePath(fileObj.filePath)
                    console.log("name", fileName)
                    //unsafe code
                    let standardDateUploadedFormat = new Date(parseInt(fileObj.dateUploaded))
                                        console.log("DU", standardDateUploadedFormat)

                    uploadedFileList.push({fileName, filePath: fileObj.filePath, dateUploaded:standardDateUploadedFormat, fileId: fileObj.fileId, contentType: fileObj.contentType})
                  }
              return uploadedFileList
    },
     handleChange: function(file, fileList){
        console.log(file)
        this.fileList = fileList; 
        console.log(this.fileList)
        let allClear = this.beforeUpload(file)
        if(!allClear){
                  this.fileList = this.fileList.filter( el => el.name !== file.name ); 

        }
        
               // console.log(fileList)

      },
     beforeUpload(file) {
    console.log("file size", file.size)
        const isLT10MB = file.size / 1024 / 1024 < 10;

      
        if (!isLT10MB) {
          this.$message.error('File size can not exceed 10MB.');
        }
        return  isLT10MB;
      },
       handleExceed(files, fileList) {
        this.$message.warning(`The number of files added is more than the limit of 10 files. Please remove one or more of your files if you would like to upload more files.`);
      },
      doAjax() {
        console.log("AJAX!")
                this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
                    this.isLoading = false
                }, 120000)
            },
            onCancel() {
                console.log('User cancelled the loader.')
            },
    uploadFiles: async function(){
    //add files to storage
          console.log("fileList", this.fileList, this.userId, this.accidentId)
      this.doAjax();
           
           
      let successfulFiles, unsuccessfulFiles;
      // let storeErr, storeRes;
      //  [ storeErr, storeRes] = await to(
         this.addImagesToStorage(this.fileList, this.userId, this.accidentId).then(async (storeRes) =>{
           console.log("storeRes", storeRes)
        
  successfulFiles = storeRes.successfulFiles
       unsuccessfulFiles = storeRes.unsuccessfulFiles
      console.log("successfulFiles", successfulFiles)
      let successfulFileObjs = [];
      for (let fileObj of successfulFiles){
        successfulFileObjs.push({"filePath":
          fileObj.filePath,
          "dateUploaded":
          Date.now().toString(),
          "fileId":
          uuidv4().toString(),
          "contentType":
          fileObj.file.raw.type})
      }
      this.parsedFilesUploaded = this.parsedFilesUploaded.concat(successfulFileObjs)
      

      let updateErr, updateRes;
      [updateErr, updateRes] = await to(this.updateDBFilesUploaded( this.parsedFilesUploaded))
      if (updateErr){
        console.error(updateErr)
      }
      this.fileList = []
      this.uploadedFileList =  this.createFileDisplayList(this.parsedFilesUploaded)//update the file list used to display in web page
      console.log("close loading Screen")
      this.isLoading = false
         }).catch(storeErr => {
            console.error(storeErr)
         throw storeErr
         })
      //  if (storeErr){

      //     console.error(storeErr)
      //     throw storeErr
      //  }
      //  console.log("store", storeRes)
     
    },
     onCancel() {
                console.log('User cancelled the loader.')
            },
  
      addImagesToStorage: async function(fileList, userId, accidentId){
        //adds all uploaded files to storage sequentially
                  console.log("fileList", fileList)

        let successfulFiles = [], unsuccessfulFiles = [];
        let metadata = {
          userId,
          accidentId}
      

        for (var file of fileList){
          console.log(file)
                const filePath = utilityFunctions.generateFirebaseStoragePath(userId, accidentId, file.name)

        var params = {
        metadata,
        file,  
        filePath,
        userToken: this.userToken
      }
        let storeErr, storeRes;
      [storeErr, storeRes] = await to(storage.upload(params))
      if (storeErr){
        unsuccessfulFiles.push({file, filePath}) //will probably need to add something in the future to handle this(like a queue)
      console.error("storeErr", storeErr, unsuccessfulFiles)
      }
      else if (storeRes){
successfulFiles.push({file, filePath})
            
      }
      console.log("successFul push", successfulFiles)

        }
        
      let resObj = {
        successfulFiles,
         unsuccessfulFiles
      }
      console.log("the end")
      const promise = new Promise((resolve, reject) => {
  resolve(resObj);
});
        return promise
      },
    handlePreview: function(file){
        console.log(file)
        console.log(this.fileList)
        this.dialogImageUrl = file.url;
        this.fileNameSelected = file.name
        this.dialogVisible = true;

      },
    
      handleSuccess : function(file){
        console.log(file)
        this.fileList.push(file); 
        console.log("success")
               // console.log(fileList)

      },
      handleError: function(error){
        console.error("UNABLE TO LOAD FILE",  error)
      },
      handleRemove: function (file) {
        console.log(file)
        this.fileList = this.fileList.filter( el => el.name !== file.name ); 
        console.log(this.fileList)
      },
    handleUpload: function(file){
        console.log("uploading",  file)
      },
     downloadFile: async function(path, fileName, contentType){
var params = {
                    filePath: path,
                    userToken: this.userToken
                  };
                  let downloadRes, downloadErr;
                  
                  [downloadErr, downloadRes] = await to(storage.download(params))
                  if(downloadErr){
                    console.error(downloadErr.data)
                  }
                  console.log(downloadRes)
                  //unsafe code
                  const blob = new File([utilityFunctions._base64ToArrayBuffer(downloadRes.data[0])], {type: contentType})
                 
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
    },

    deleteFile: async function(path, fileName, fileId){

      let userNo, userYes;
        [userNo, userYes] = await to(this.$confirm("Are you sure you want to delete this file?" ,  'WARNING', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'}))

        if (userNo){
            console.log("no")
        }
   
        if(userYes){
        var params = {
                    filePath: path,
                    userToken: this.userToken
                  };
               
                 this.parsedFilesUploaded =  this.parsedFilesUploaded.filter(e => e.fileId !== fileId);
        this.uploadedFileList =  this.uploadedFileList.filter(e => e.fileId !== fileId);

         let updateErr, updateRes;
         [updateErr, updateRes] = await to(this.updateDBFilesUploaded( this.parsedFilesUploaded))
         if(updateErr){
            this.$confirm("Unable to delete File. Please try again at a later time.", 'Delete Accident Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'})
           throw updateErr
         }
                  let deleteRes, deleteErr;
                  
                  [deleteErr, deleteRes] = await to(storage.deleteFile(params))
                 
                  if (deleteErr){
                      console.error(deleteErr.data)
                     this.$confirm("Unable to delete File. Please try again at a later time.", 'File Delete Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'})
                  }
this.$confirm("File successfully deleted.", 'File Deleted Successfully', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'info'})

    }},
    updateModelDropdown(){
          this.modelValue = ''
          this.yearValue=  ''
          this.modelOptions =  this.makeOptions.filter(e => e.brand === this.makeValue)[0].models;//unsafe
          console.log("changed", this.modelOptions)
      },
   saveChanges: function(){
     setTimeout(this._saveChanges, 500)
   },
    _saveChanges: async function () {
     
      //if a new date value was entered
      if(this.dateValue){
        this.accidentDate = this.dateValue
      }
      this.$confirm("Do you want to save these changes?", "Update Accident Infomation", {
        cancelButtonText: "Cancel",
        confirmButtonText: "OK",
        type: "info",
      })
        .then((res) => {
          this.updateDB();
        })
        .then((res) => {
          console.log("uploaded");
          this.updateClientStorage(
            this.accidentName,
            this.accidentDate,
            this.accidentTypeSelect,
            this.makeValue,
            this.modelValue,
            this.YearValue,
            this.additionalInfoTextArea,
            this.servicesNeededCheckList
          );
          this.$router.push("/accidents/AccidentList");
        })
        .catch((err) => {
          return;
        });
    },
    updateDB: async function () {

      let dbArrValues = [];
      for(var service of this.servicesNeededCheckList){
            dbArrValues.push({"stringValue": service})
        }
              console.log("accident Time",this.timeValue)
            


        

      let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.updateAccident(this.userToken, this.userAccountId,this.accidentId, this.accidentTypeSelect, this.accidentName, this.timeValue, this.dateValue, this.vehicleSpeedValue.toString(), this.accidentLocation, this.makeValue, this.modelValue, this.yearValue.toString(), this.additionalInfoTextArea, dbArrValues))
        
      if (dbErr) {
        console.error("ERROR", dbErr);
        throw err;
      } else if (dbRes) {
        console.log("accident updated in DB!", dbRes);
      }
    },
    updateDBFilesUploaded: async function ( filesUploaded) {
      
      let formattedFilesUploaded = utilityFunctions.formatArrayOfObjectsGoogleFirestoreDB(filesUploaded)
       

      let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.updateAccidentFiles(this.userToken, this.userAccountId,this.accidentId, formattedFilesUploaded));
      if (dbErr) {
        console.error("ERROR", dbErr);
        throw err;
      } else if (dbRes) {
        console.log("accident updated in DB!", dbRes);
      }
    },
    updateClientStorage: function(accidentName, accidentDate, accidentType, vehicleMake, vehicleModel, vehicleYear, additionalInfo, servicesNeeded){
        this.accidentName = localStorage.setItem(cliStorNames.ACCIDENT_NAME.name, accidentName)
     this.accidentType = localStorage.setItem(cliStorNames.ACCIDENT_TYPE.name, accidentType)
      this.accidentDate = localStorage.setItem(cliStorNames.ACCIDENT_DATE.name, accidentDate)
       this.YearValue = localStorage.setItem(cliStorNames.VEHICLE_YEAR.name, vehicleYear)
     this.modelValue = localStorage.setItem(cliStorNames.VEHICLE_MODEL.name, vehicleModel)
      this.makeValue = localStorage.setItem(cliStorNames.VEHICLE_MAKE.name, vehicleMake)
       this.additionalInfo = localStorage.setItem(cliStorNames.ADDITIONAL_TEXT.name, additionalInfo)
        this.servicesNeeded = localStorage.setItem(cliStorNames.SERVICES_REQUESTED.name, servicesNeeded)

    },
    
  },
};
</script>



// WEBPACK FOOTER //
// EditAccident.vue?d0e70f1c